import { forwardRef, useImperativeHandle } from "react";
import useAddCostPanel from "../../hooks/useAddCostPanel";
import usePrefetchFormulaReferences from "../../hooks/usePrefetchFormulaReferences";
import type { SaveInputsAndExecuteCallerVariables } from "../../hooks/useSaveInputsAndExecute";
import type { CategoryGroup } from "../../hooks/useCalculationDetail";
import CostPanel from "./CostPanel.component";

export interface CostPanelHandle {
  open: () => void;
}

interface CostPanelContainerProps {
  categoryGroups: CategoryGroup[];
  pageActiveCategoryId: string;
  pageActiveSubcategoryId: string;
  onConflict: () => void;
  onSave: (variables: SaveInputsAndExecuteCallerVariables) => void;
  isSaving: boolean;
}

const CostPanelContainer = forwardRef<CostPanelHandle, CostPanelContainerProps>(
  (
    {
      categoryGroups,
      pageActiveCategoryId,
      pageActiveSubcategoryId,
      onConflict,
      onSave,
      isSaving,
    },
    ref,
  ) => {
    const panel = useAddCostPanel({
      categoryGroups,
      pageActiveCategoryId,
      pageActiveSubcategoryId,
      onConflict,
      onSave,
    });

    usePrefetchFormulaReferences(panel.activeSubcategoryId, panel.panelActive);

    useImperativeHandle(ref, () => ({ open: panel.openPanel }), [
      panel.openPanel,
    ]);

    return <CostPanel {...panel.panelProps} isSaving={isSaving} />;
  },
);

CostPanelContainer.displayName = "CostPanelContainer";

export default CostPanelContainer;
